

export class RoutePathAddInput implements IRoutePathAddInput {
    /** The auto-generated id of the license to branch details  master */
    branchDetailId!: number;
    /** The path name with 255 character limit */
    pathName!: string;
    /** The start point with 5000 character limit */
    startPoint!: string;
    /** The start point with 5000 character limit */
    endPoint!: string;
    /** The authorized halt tolerance should be 0 or 1 */
    authorizedHaltTolerance!: number;
    /** The description with 5000 character limit */
    description!: string;

    constructor(data?: IRoutePathAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
            this.pathName = _data["pathName"];
            this.startPoint = _data["startPoint"];
            this.endPoint = _data["endPoint"];
            this.authorizedHaltTolerance = _data["authorizedHaltTolerance"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoutePathAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        data["pathName"] = this.pathName;
        data["startPoint"] = this.startPoint;
        data["endPoint"] = this.endPoint;
        data["authorizedHaltTolerance"] = this.authorizedHaltTolerance;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRoutePathAddInput {
    /** The auto-generated id of the license to branch details  master */
    branchDetailId: number;
    /** The path name with 255 character limit */
    pathName: string;
    /** The start point with 5000 character limit */
    startPoint: string;
    /** The start point with 5000 character limit */
    endPoint: string;
    /** The authorized halt tolerance should be 0 or 1 */
    authorizedHaltTolerance: number;
    /** The description with 5000 character limit */
    description: string;
}

